"use client"

import { LoadingSpinner } from "@/components/ui/spinner"

interface PricingLoadingOverlayProps {
    show: boolean
}

export function PricingLoadingOverlay({ show }: PricingLoadingOverlayProps) {
    if (!show) return null

    return (
        <div className="absolute inset-0 flex top-[90px] pt-[60px] justify-center bg-white bg-opacity-75 z-10">
            <LoadingSpinner />
        </div>
    )
}
